import { render, staticRenderFns } from "./chateau-rauzan-segla.vue?vue&type=template&id=5f90732d&scoped=true"
import script from "./chateau-rauzan-segla.vue?vue&type=script&lang=js"
export * from "./chateau-rauzan-segla.vue?vue&type=script&lang=js"
import style0 from "./chateau-rauzan-segla.vue?vue&type=style&index=0&id=5f90732d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90732d",
  null
  
)

export default component.exports